import React, { useEffect, useState } from 'react';
import Headers from '../components/Header';
import { FaCheckCircle } from 'react-icons/fa'; // Importing checkmark icon from react-icons
import NumberFlow from '@number-flow/react'; // Use the default export
import LogoSection from './LogoSection';
import Footer from './Footer'
import Weinclude from '../components/Weinclude'
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';

const Subscription = () => {

  const [plans, setPlans] = useState([]); // State to store subscription plans
  const [isLoading, setIsLoading] = useState(true); // State to handle loading
  const [error, setError] = useState(null); // State to handle errors
  const navigate = useNavigate();


  useEffect(() => {
    const fetchPlans = async () => {
      // const conuntyid = sessionStorage.getItem('conuntyid')
      const serviceid = parseInt(sessionStorage.getItem('serviceid'), 10)
      try {
        // const response = await fetch(`https://verse.blaccdot.com/ldsstagingindia/masters/subscription/all/${conuntyid}`);
       const response = await fetch(`https://verse.blaccdot.com/ldsstagingindia/masters/subscription/categorybased/${serviceid}`);
        if (!response.ok) {
          throw new Error('Failed to fetch plans');
        }
        const data = await response.json();
        const subscriptionMasters = data?.data?.subscriptionmasters || [];

        const formattedPlans = subscriptionMasters.map((plan, index) => ({
          id: plan._id,
          subscriptionmasterId:plan.subscriptionmasterId,
          title: plan.title,
          monthlyPrice: plan.monthAmount,
          annualPrice: plan.anualAmount,
          currency: plan.currency,
          taxAmount: plan.taxAmount,
          description: `${plan.creditpoints}`,
          features: plan.textcontent ? Object.values(plan.textcontent) : [], 
          highlighted: index === 1, 
        }));       
        setPlans(formattedPlans);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlans();
  }, []);

  const handleRediract = (plan) => {
    sessionStorage.setItem("subscriptionID", plan.subscriptionmasterId); 
    sessionStorage.setItem('planTitle', plan.title)
    sessionStorage.setItem('planAmount', plan.monthlyPrice)
    sessionStorage.setItem('plantax', plan.taxAmount) 
    sessionStorage.setItem('planTitle', plan.title)
    sessionStorage.setItem('countrycode', plan.currency)
    sessionStorage.setItem('credit', plan.description);   
    navigate('/signup');
  };


  
  const handleCustomFetch = async ()=>{
    const formID = sessionStorage.getItem('finalFormID')
    const payload = {
      user_type: "custom"
    }
    try {
      const response = await fetch(`https://euctostaging.com/ldsstagingindia/api/businessinitialform/update/${formID}`,{
        method:'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json()
      navigate('/appointment');
    } catch (error) {
      console.log('error', error)
    }
  }

  // const handleCustomFetch = ()=>{
  //   navigate('/appointment');
  // }
 

  return (
    <>
      <Headers />
      <div className="pricing-container">
        <h1 className="pricing-title">Plans That Fit Your Business</h1>
        <p className="pricing-subtitle">
          From startups to enterprises, find the right solution to boost your business growth.
        </p>

        {/* Mapping through the plans array to render pricing cards dynamically */}
        <div className="pricing-cards">
        {plans.length > 0
            ? plans.map((plan) => (
                <div
                key={plan.subscriptionmasterId}
                  className={`pricing-card ${plan.highlighted ? "highlighted" : ""}`}>
                  <div className="plan-header">
                    <h2>{plan.title}</h2>
                    <p className="price">
                      <NumberFlow
                        value={plan.monthlyPrice}
                        duration={1000}
                        format="currency"/><span style={{fontSize:'15px', marginLeft:'5px'}}>{plan.currency || ''}</span>
                      <span className="billing-info">+ Taxes</span>
                    </p>
                    <p className="description">{plan.description} credit included</p>
                  </div>
                  <ul className="feature-list">
            {plan.features.length > 0 ? (
              plan.features.map((feature, idx) => (
                <li key={idx}>
                  <FaCheckCircle id="icon" className="icon" /> {feature}
                </li>
              ))
            ) : (
              <li>No features available</li>  
            )}
          </ul>


                  <button onClick={() => handleRediract(plan)} className={`choose-plan-button ${plan.highlighted ? "highlighted-button" : ""}`}>
                    Choose {plan.title}</button>
                </div>
              ))  : !isLoading && <p>No plans available</p>}
         {/* Custom */}
            {/* <div className={`pricing-card`}>
              <div className="plan-header">
                <h2>Custom</h2>
                <p className="pricecustom">
                  <span>Make Your Own</span>
                  <span className="billing-info mt-2">Tailored to your needs</span>
                </p>
                <p className="tax-info">+ Taxes</p>
              </div>
              <ul className="feature-list">
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> Custom your own
                  </li>
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> Custom your own
                  </li>
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> Custom your own
                  </li>
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> Custom your own
                  </li>
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> Custom your own
                  </li>
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> Custom your own
                  </li>
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus
                  </li>
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> Long Distance Moves leads
                  </li>
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> Custom your own
                  </li>
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> Custom your own
                  </li>
                  <li>
                    <FaCheckCircle  id="icon" className="icon iconsub" /> We accept Card/Paypal
                  </li>
              </ul>
             <button onClick={handleCustomFetch} className="choose-plan-button">Choose Custom</button>
            </div> */}
        </div>


      </div>
      <>
        <LogoSection/>
      </>
      <>
        <Weinclude/>
      </>
      <>
        <Footer/>
      </>
   
    </>
  );
};

export default Subscription;



// import React, { useEffect, useState } from 'react';
// import Headers from '../components/Header';
// import { FaCheckCircle } from 'react-icons/fa'; // Importing checkmark icon from react-icons
// import NumberFlow from '@number-flow/react'; // Use the default export
// import LogoSection from './LogoSection';
// import Footer from './Footer'
// import Weinclude from '../components/Weinclude'
// import { useNavigate } from 'react-router-dom';
// import Button from '@mui/material/Button';

// const Subscription = () => {

//   const [plans, setPlans] = useState([]); // State to store subscription plans
//   const [isLoading, setIsLoading] = useState(true); // State to handle loading
//   const [error, setError] = useState(null); // State to handle errors
//   const navigate = useNavigate();


//   useEffect(() => {
//     const fetchPlans = async () => {
//       try {
//         const response = await fetch('https://verse.blaccdot.com/ldsstagingindia/masters/subscription/all');
//         if (!response.ok) {
//           throw new Error('Failed to fetch plans');
//         }
//         const data = await response.json();
//         const formattedPlans = data?.data?.subscriptionmasters.map((plan, index) => ({
//           id: plan._id,
//           subscriptionmasterId:plan.subscriptionmasterId,
//           title: plan.title,
//           monthlyPrice: plan.monthAmount,
//           annualPrice: plan.anualAmount,
//           taxAmount: plan.taxAmount,
//           description: `${plan.creditpoints}`,
//           features: Object.values(plan.textcontent), 
//           highlighted: index === 1, 
//         }));       
//         setPlans(formattedPlans);
//       } catch (error) {
//         setError(error.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchPlans();
//   }, []);

//   const handleRediract = (plan) => {
//     sessionStorage.setItem("subscriptionID", plan.subscriptionmasterId); 
//     sessionStorage.setItem('planTitle', plan.title)
//     sessionStorage.setItem('planAmount', plan.monthlyPrice)
//     sessionStorage.setItem('plantax', plan.taxAmount) 
//     sessionStorage.setItem('planTitle', plan.title)
//     sessionStorage.setItem('credit', plan.description);   
//     navigate('/signup');
//   };
//   const handleCustomFetch = async ()=>{
//     const formID = sessionStorage.getItem('finalFormID')
//     const payload = {
//       user_type: "custom"
//     }
//     try {
//       const response = await fetch(`https://euctostaging.com/ldsstagingindia/api/businessinitialform/update/${formID}`,{
//         method:'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(payload)
//       });

//       const result = await response.json()
//       navigate('/appointment');
//     } catch (error) {
//       console.log('error', error)
//     }
//   }

//   // const handleCustomFetch = ()=>{
//   //   navigate('/appointment');
//   // }
 

//   return (
//     <>
//       <Headers />
//       <div className="pricing-container">
//         <h1 className="pricing-title">Plans That Fit Your Business</h1>
//         <p className="pricing-subtitle">
//           From startups to enterprises, find the right solution to boost your business growth.
//         </p>

//         {/* Mapping through the plans array to render pricing cards dynamically */}
//         <div className="pricing-cards">
        // {plans.length > 0
        //     ? plans.map((plan) => (
        //         <div
        //         key={plan.subscriptionmasterId}
        //           className={`pricing-card ${plan.highlighted ? "highlighted" : ""}`}>
        //           <div className="plan-header">
        //             <h2>{plan.title}</h2>
        //             <p className="price">
        //               <NumberFlow
        //                 value={plan.monthlyPrice}
        //                 duration={1000}
        //                 format="currency"/>
        //               <span className="billing-info">+ Taxes</span>
        //             </p>
        //             <p className="description">{plan.description} credit included</p>
        //           </div>
        //           <ul className="feature-list">
        //             {plan.features.map((feature, idx) => (
        //               <li key={idx}>
        //                 <FaCheckCircle id="icon" className="icon"/> {feature}
        //               </li>
        //             ))}
        //           </ul>
        //           <button onClick={() => handleRediract(plan)} className={`choose-plan-button ${plan.highlighted ? "highlighted-button" : ""}`}>
        //             Choose {plan.title}</button>
        //         </div>
        //       ))  : !isLoading && <p>No plans available</p>}
//          {/* Custom */}
//             <div className={`pricing-card`}>
//               <div className="plan-header">
//                 <h2>Custom</h2>
//                 <p className="pricecustom">
//                   <span>Make Your Own</span>
//                   <span className="billing-info mt-2">Tailored to your needs</span>
//                 </p>
//                 <p className="tax-info">+ Taxes</p>
//               </div>
//               <ul className="feature-list">
//                   <li>
//                     <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus
//                   </li>
//                   <li>
//                     <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus
//                   </li>
//                   <li>
//                     <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus
//                   </li>
//                   <li>
//                     <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus
//                   </li>
//                   <li>
//                     <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus
//                   </li>
//                   <li>
//                     <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus
//                   </li>
//                   <li>
//                     <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus
//                   </li>
//                   <li>
//                     <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus eatures Plus
//                   </li>
//                   <li>
//                     <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus
//                   </li>
//                   <li>
//                     <FaCheckCircle  id="icon" className="icon iconsub" /> All Pro Plan Features Plus
//                   </li>
//               </ul>
//              <button onClick={handleCustomFetch} className="choose-plan-button">Choose Custom</button>
//             </div>
//         </div>


//       </div>
//       <>
//         <LogoSection/>
//       </>
//       <>
//         <Weinclude/>
//       </>
//       <>
//         <Footer/>
//       </>
   
//     </>
//   );
// };

// export default Subscription;



